import * as yup from "yup";

import { useEffect } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "../../../components/common/ReactSelect";

import taxService from "../../../services/taxService";
import moment from "moment";

const schema = yup.object();

const ReceiptFilter = ({ options, onFilter }) => {
  const quarters = taxService.getAltTaxQuarters();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const getYears = () => {
    let current_year = moment().add(1, "y").format("yyyy");
    let start_year = 2000;

    const options = [];

    while (current_year >= start_year) {
      options.push({
        value: current_year,
        label: current_year,
      });

      current_year -= 1;
    }

    return options;
  };

  const onSubmit = (info) => {
    const year = info.year && info.year !== undefined ? info.year.value : "";
    const quarter =
      info.quarter && info.quarter !== undefined ? info.quarter.value : "";

    onFilter(year, quarter);
  };

  const handleReset = () => {
    const year = "";
    const quarter = "";

    onFilter(year, quarter);
  };

  useEffect(() => {
    if (options) {
      const { year, quarter } = options;

      if (year) setValue("year", { value: year, label: year });
      if (quarter) {
        const quarters = taxService.getAltTaxQuarters();
        const selected = quarters.filter((i) => i.value === quarter);
        setValue("quarter", selected[0]);
      }
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-1">
          <ReactSelect
            id="year-dropdown"
            name="year"
            title="Year"
            options={getYears()}
            control={control}
            register={register("year")}
            errors={errors}
            isClearable
          />
        </div>
        <div className="col-span-1">
          <ReactSelect
            id="quarter-dropdown"
            name="quarter"
            title="Quarter"
            options={quarters}
            control={control}
            register={register("quarter")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default ReceiptFilter;
